module.exports = __webpack_public_path__ + "static/media/fsyuce001.99138493.png";